import { useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { AppContext } from '@/contexts/app-context';

export type ShareProps = {
    label: string;
    pageTitle: string;
    pageSummary?: string;
};

export const Share = ({ label, pageTitle, pageSummary }: ShareProps) => {
    const context = useContext(AppContext);
    const { pathname, search, hash } = useLocation();
    const searchParam = search === '?' ? '' : search;
    const url = useMemo(() => `${context.url}${pathname}${searchParam}${hash}`, [context, pathname, searchParam, hash]);

    function generateUrl(baseUrl: string, params: Record<string, string | null | undefined>) {
        const searchParams = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });
        return `${baseUrl}?${searchParams.toString()}`;
    }

    return (
        <div className="r-flex r-items-center r-gap-4">
            <p className="r-font-bold">{label}</p>
            <div>
                <a
                    href={generateUrl('http://www.linkedin.com/shareArticle', {
                        mini: 'true',
                        url,
                        title: pageTitle,
                        summary: pageSummary,
                    })}
                    className="no-icon"
                    target="_blank"
                >
                    <img width={30} height={30} src="/assets/icons/linkedin.svg" alt="LinkedIn Logo" />
                </a>
            </div>
            <div>
                <a className="no-icon" href={generateUrl('https://facebook.com/sharer/sharer.php', { u: url })} target="_blank">
                    <img width={30} height={30} src="/assets/icons/facebook.svg" alt="Facebook Logo" />
                </a>
            </div>
            <div>
                <a className="no-icon" href={generateUrl('https://twitter.com/intent/tweet', { url, text: pageTitle })} target="_blank">
                    <img width={30} height={30} src="/assets/icons/twitter.svg" alt="Twitter Logo" />
                </a>
            </div>
        </div>
    );
};
